import type * as React from "react";

import type { IconComponentProps } from "../icon-types.ts";

// Microsoft Outlook product mark, simplified to its read: the envelope behind,
// the blue "O" tile in front. Brand colors are literal on purpose — a mark
// never takes the theme's ink, so `color` and `strokeWidth` are dropped.
const OUTLOOK_BRAND = {
  envelopeTop: "#0364B8",
  envelopeBody: "#28A8EA",
  envelopeFlap: "#0078D4",
  tile: "#0F78D4",
  tileShade: "#0A5DAD",
  ring: "#FFFFFF",
} as const;

export function MicrosoftOutlookLogo({
  size = 24,
  ref,
  ...props
}: IconComponentProps): React.ReactElement {
  const { color: _color, strokeWidth: _strokeWidth, ...rest } = props;
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path fill={OUTLOOK_BRAND.envelopeBody} d="M9 6h13a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H9z" />
      <path fill={OUTLOOK_BRAND.envelopeTop} d="M9 6h13a1 1 0 0 1 1 1v5H9z" />
      <path
        fill={OUTLOOK_BRAND.envelopeFlap}
        d="M9 12h14v1.1l-6.55 4.1a1 1 0 0 1-1.06 0L9 13.1z"
      />
      <rect fill={OUTLOOK_BRAND.tileShade} height="14" rx="1.6" width="12" x="1.5" y="5.5" />
      <rect fill={OUTLOOK_BRAND.tile} height="14" rx="1.6" width="12" x="1" y="5" />
      <ellipse
        cx="7"
        cy="12"
        fill="none"
        rx="3.1"
        ry="3.7"
        stroke={OUTLOOK_BRAND.ring}
        strokeWidth="1.9"
      />
    </svg>
  );
}
